import Vue from 'vue';
import Vuex from 'vuex';

import { getCountyInfo } from '../wallid/utils.js';
import * as WallidConst from '../wallid/const.js';

import * as modules from './modules';

import axios from 'axios';
import {
  SEND_MESSAGE,
  GET_TOKEN_METAMASK,
  GET_TOKEN_WALLET,
  VERIFY_WALLET,
  START_TSP,
  VERIFY_DATA_ID,
  HANDLE_ASSETS,
} from './consts';

import { ASSET_NAMES } from '@/wallid/const';

import { ethers } from 'ethers';

Vue.use(Vuex);

const logger = {
  log: require('debug')('iframe:loggerStore'),
  error: require('debug')('iframe:error:loggerStore'),
};

const BASE_TSP_URL = window.TSP_URL || process.env.VUE_APP_BASE_TSP_URL;

const WALLID_API = 'https://api.wallid.io/api/v1';

const GET_USER_CERTIFICATE = '/userCertificate';

const provider = new ethers.providers.JsonRpcProvider(
  'https://mainnet.infura.io/v3/463ed0e7b23c41178adf46fd4fbbc7c2'
);

let store = new Vuex.Store({
  modules,
  state: {
    idAssets: [],
    loading: true,
    confirmed: false,
    password: null,
    snackbar: false,
    envelopeID: 'x5092CE8A7A-D072-4086-9E9D-256616E7F416',
    documents: ['Name_doc1', 'Name_doc2', 'Name_doc3'],
    authToken: null,
    confirm: false,
    currentUrl: '',
    showIdentitiesStatus: false,
    dropdown_identity: {
      en: {
        CMD_PT: {
          text: 'Chave Móvel Digital - Portuguese Republic',
          type: '',
          document: 'Chave Móvel Digital',
          entity: 'Portuguese Republic',
        },
        CC_PT: {
          text: 'Citizen Card - Portuguese Republic ',
          type: ' - Qualified Signature',
          document: 'Citizen Card',
          entity: 'Portuguese Republic',
          idt: 'CC_PT',
        },
        SHUFTI_CC_PT: {
          text: 'Citizen Card - Portuguese Republic ',
          type: '- Advanced Signature',
          document: 'Citizen Card',
          entity: 'Portuguese Republic',
        },
        SHUFTI_CC: {
          text: 'Citizen Card ',
          type: '',
          document: 'Citizen Card',
          entity: '',
        },
        SHUFTI_CC_CH: {
          text: 'Identity Card - Swiss Confederation',
          type: '',
          document: 'Identity Card',
          entity: 'Swiss Confederation ',
        },
        SHUFTI_CC_FR: {
          text: "Carte d'identité",
          type: '',
          document: "Carte d'identité",
          entity: 'French Republic',
        },
        SHUFTI_CC_MO: {
          text: 'Macau Resident Identity Card',
          type: '',
          document: 'Macau Resident Identity Card',
          entity: 'Macau',
        },
      },
      pt: {
        CMD_PT: {
          text: 'Chave Móvel Digital - Republica Portuguesa',
          type: '',
          document: 'Chave Móvel Digital',
          entity: 'Republica Portuguesa',
        },
        CC_PT: {
          text: 'Cartão de Cidadão - Republica Portuguesa ',
          type: '- Assinatura Qualificada',
          document: 'Cartão de Cidadão',
          entity: 'Republica Portuguesa',
        },
        SHUFTI_CC_PT: {
          text: 'Cartão de Cidadão - Republica Portuguesa',
          type: ' - Assinatura Avançada',
          document: 'Cartão de Cidadão',
          entity: 'Republica Portuguesa',
        },
        SHUFTI_CC: {
          text: 'Cartão de Cidadão',
          type: '',
          document: 'Cartão de Cidadão',
          entity: '',
        },
        SHUFTI_CC_CH: {
          text: 'Identity Card - Swiss Confederation',
          type: '',
          document: 'Identity Card',
          entity: 'Swiss Confederation ',
        },
        SHUFTI_CC_FR: {
          text: "Carte d'identité",
          type: '',
          document: "Carte d'identité",
          entity: 'Républica Francesa',
        },
        SHUFTI_CC_MO: {
          text: 'Bilhete de Identidade de Residente',
          type: '',
          document: 'Bilhete de Identidade de Residente',
          entity: 'Macau',
        },
      },
    },
    step: 0,
    errorMsg: '',
    data: [],
    dataId: '',
    dataVerifyId: '',
    dataVerifyIdEncrypted: '',
    dataIdentityIdEncrypted: '',
    dataIdentityId: '',
    idt: null,
    verifyIDToken: '',
    identitiesEnum: {
      CC_PT: 1,
      CMD_PT: 2,
      'Repúblique Française - France': 3,
      'Documento Nacional de Indentidad - Spain': 4,
      'Sverige Sweden Suéde - Sweden': 5,
      properties: {
        1: {
          name: 'Cartão de Cidadão - República Portuguesa',
          value: 1,
          code: 'CC_PT',
        },
        2: {
          name: 'Chave Móvel Digital - República Portuguesa',
          value: 2,
          code: 'CMD_PT',
        },
        3: { name: 'Repúblique Française - France', value: 3, code: '' },
        4: {
          name: 'Documento Nacional de Indentidad - Spain',
          value: 4,
          code: '',
        },
        5: { name: 'Sverige Sweden Suéde - Sweden', value: 5, code: '' },
      },
    },

    redirectUrl: '',
    signing: false,
    terms: false,
    verify: false,
    session_id_tsp: window.session_id_tsp,
    errorMsgStatus: null,
    selectedAsset: null,
  },

  actions: {
    [START_TSP]: ({ state }, { asset, waSignature }) => {
      logger.log('START_TSP Action', asset, waSignature);

      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();

        const { countryCode, country } = getCountyInfo();

        params.append('idt', 'WALLET_ADDR');
        params.append('wallet', state.plugin.walletAddress);
        params.append('commonName', asset?.username);
        params.append('waSignature', waSignature);
        params.append('countryCode', countryCode);
        params.append('country', country);

        params.append('tspwallid_signing_session', state.session_id_tsp);

        axios
          .post(BASE_TSP_URL + START_TSP, params)
          .then((res) => {
            logger.log(res);
            resolve(res.data);
          })
          .catch((err) => {
            logger.error(err);
            reject(handleError(err));
          });
      });
    },
    [VERIFY_WALLET]: ({ state, commit }, authToken) => {
      logger.log('VERIFY_WALLET Action');

      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        logger.log(authToken);
        params.append('authorization', authToken);
        params.append('tspwallid_signing_session', state.session_id_tsp);
        resolve('token');

        axios
          .post(BASE_TSP_URL + VERIFY_WALLET, params)
          .then((res) => {
            logger.log(res);
            if (res.data.data.verified) {
              commit('verifyIDToken', res.data.data.verifyIDToken);
              resolve(res.data.data.verifyIDToken);
            } else {
              reject(false);
            }
          })
          .catch((err) => {
            logger.error(err);
            reject(handleError(err));
          });
      });
    },
    [GET_TOKEN_WALLET]: ({ state }) => {
      logger.log('GET_TOKEN_WALLET Action');

      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('wallet', state.plugin.walletAddress);
        params.append('tspwallid_signing_session', state.session_id_tsp);
        try {
          // axios
          //   .post(BASE_TSP_URL + GET_TOKEN_WALLET, params)
          //   .then((res) => {
          //     logger.log(res);
          //     let token = res.data.data.challenge;
          //     window.wallid('wallet_sign_ec', [token]).then((signature) => {
          //       logger.log('signed challenge');
          let token = 'test_token';
          let signature = 'test_signature';
          resolve(Buffer.from(token + ':' + signature).toString('base64'));
        } catch (error) {
          logger.error(error);
          reject(error);
        }
      });
    },

    [VERIFY_DATA_ID]: ({ state, commit }) => {
      logger.log('VERIFY_DATA_ID Action');

      return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('wallet', state.plugin.walletAddress);
        params.append('idt', state.idt.value);
        params.append('identity_id', JSON.stringify(state.dataIdentityId));
        params.append('verify_id', JSON.stringify(state.dataVerifyId));
        params.append('tspwallid_signing_session', state.session_id_tsp);

        axios
          .post(BASE_TSP_URL + VERIFY_DATA_ID, params)
          .then((res) => {
            logger.log(res);
            if (res.data.data.verified) {
              commit('verifyIDToken', res.data.data.verifyIDToken);

              resolve(res.data.data.verifyIDToken);
            } else {
              reject(false);
            }
          })
          .catch((err) => {
            logger.error(err);
            reject(err);
          });
      });
    },

    [GET_TOKEN_METAMASK]: ({ state }, { idt }) => {
      logger.log('GET_TOKEN_METAMASK:');
      return new Promise((resolve) => {
        const params = new URLSearchParams();
        params.append('client_id', 'wallid-web-dev');
        params.append('client_secret', 'password');

        let auth_url = WallidConst.AUTH_CHALLENGE;
        var body = {
          idt: idt.value,
          wallet: state.plugin.walletAddress,
          operation: 'verify',
        };
        axios(auth_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          params,
          data: body,
        })
          .then((response) => {
            logger.log(
              'Response Data ',
              response,
              ' token ',
              response.data.challenge
            );
            if (response.data.challenge.length > 0) {
              var token = response.data.challenge;

              window.web3.eth.personal.sign(
                token,
                state.plugin.walletAddress,
                function(err, signature) {
                  resolve(btoa(token + ':' + signature));
                }
              );
            } else {
              alert('Error in authentication ' + response.data.message);
            }
          })
          .catch((error) => {
            logger.log(error);
            alert('Fail getting auth token');
            // self.$eventHub.$emit("eventUpdate", {
            //   time: 1,
            //   params: {
            //     msg: self.$i18n.t("intercom.button"),
            //   },
            // });
          });
      });
    },
    [SEND_MESSAGE]: ({ state, commit }, params) => {
      logger.log('send Message to intercom  call, msg:', params.msg);
      return new Promise((resolve, reject) => {
        axios
          .post(WallidConst.BASE_URL_API + WallidConst.INTERCOM, {
            msg: params.msg,
            user_id: params.user_id,
            msgID: state.msgID,
          })
          .then((response) => {
            if (response.data.msgID) commit('msgID', response.data.msgID);
            resolve(response);
          })
          .catch((error) => {
            logger.log(error.response);
            logger.log(state.status);

            reject(error.response);
          });
      });
    },
    async handleCredentials({ state, commit }, { credentials = [] }) {
      logger.log('handleCredentials', credentials, state.idAssets);
      let lastIndex = -1;
      // dont use identities for now
      credentials.forEach((e, index) => {
        const idt = e.id;
        const idtName = e.assetName;
        const username = e.username;

        // logger.log(idt);

        if (idtName == ASSET_NAMES.METAMASK || idtName == ASSET_NAMES.ENS) {
          commit('addAsset', {
            text: '',
            name: idtName,
            id: idt,
            value: username,
            username: username,
            controller: 'credentials',
          });
          // last credential index
          lastIndex = index;
        }
      });
      return lastIndex;
    },
    handleIdentities({ state }, { identities = [] }) {
      logger.log('idtsList', identities, state.idAssets);
      // dont use identities for now
      return;

      // idtsList.forEach((e) => {
      //   const idt = e.idt;
      //   const idtName = e.idtName;

      //   logger.log(idt);

      //   this.entities.push({
      //     text: idtName,
      //     id: idt,
      //     value: idt,
      //   });

      //   if (idt == 'CMD_PT') {
      //     this.idt = {
      //       text: idtName,
      //       value: idt,
      //     };
      //   }
      // });
    },
    GET_USER_CERTIFICATE(context, { wa, walletSignature, idt }) {
      logger.log('GET_USER_CERTIFICATE Action', wa, context);

      const body = {
        wallet: wa,
        idt,
        walletSignature,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(WALLID_API + GET_USER_CERTIFICATE, body)
          .then(({ data }) => {
            logger.log(data);
            if (data?.data.idAttributes && data?.data.verifyBlock) {
              resolve(data.data);
            } else {
              reject(new Error('No data'));
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async genStoreMyWalliDCerticate({ commit, dispatch }, { address }) {
      const domain = await provider.lookupAddress(address);

      logger.log('address', address);
      const res = await dispatch('GET_USER_CERTIFICATE', {
        wa: domain || address,
        idt: 'MyWalliD',
      }).catch((e) => {
        this.logError(e);
      });
      logger.log('generateStoreMyWallidCert result: ', res);

      const profile = {
        username: domain || address,
        socialName: 'MyWalliD',
      };
      // Store in plugin
      commit('plugin/profile', profile);
      const result = await dispatch('plugin/IMPORT_ONLINE_ID', {
        ...res,
        ...profile,
      }).catch((err) => {
        throw err;
      });

      logger.log('generateStoreMyWallidCert result: ', result);
      return result;
    },

    async handleProfiles({ commit }, { profiles = [] }) {
      logger.log('profiles', profiles);

      profiles.forEach((e) => {
        const idt = e.id;
        const idtName = e.socialName;
        const username = e.domainENS || e.username;

        logger.log(idt);
        // for now only use metamask profile
        if (idtName == ASSET_NAMES.METAMASK) {
          commit('addAsset', {
            text: '',
            name: idtName,
            id: idt,
            value: username,
            username: username,
            controller: 'profiles',
          });
        }
      });

      // NO LONGER REQUIRED, as now the certificates are generated in backend 1/3/2022
      // Check if there is a MYWAllID in entities if not generate certificate and store in plugin
    },
    [HANDLE_ASSETS]: async (
      { state, commit, dispatch },
      { identities, profiles, credentials }
    ) => {
      logger.log('Action HANDLE_ASSETS', identities, profiles);

      commit('idAssets', []);
      // first add wallid address option
      commit('addAsset', {
        text: '',
        name: 'MyWalliD',
        id: 'MyWalliD:' + state.plugin.walletAddress,
        value: state.plugin.walletAddress,
        username: state.plugin.walletAddress,
      });

      await dispatch('handleIdentities', { identities });
      await dispatch('handleProfiles', { profiles });
      let lastIndex = await dispatch('handleCredentials', { credentials });

      // add the option to always store another ens or metamask
      commit('addAsset', {
        text: 'Add an address from another wallet',
        name: ASSET_NAMES.METAMASK,
        id: `${ASSET_NAMES.METAMASK}_NOT_IN_WALLET`,
        value: `${ASSET_NAMES.METAMASK}_NOT_IN_WALLET`,
        username: '',
      });
      commit('addAsset', {
        text: 'Add an ENS domain',
        name: ASSET_NAMES.ENS,
        id: `${ASSET_NAMES.ENS}_NOT_IN_WALLET`,
        value: `${ASSET_NAMES.ENS}_NOT_IN_WALLET`,
        username: '',
      });

      logger.log('Action idAssets', state.idAssets);

      if (state.idAssets.length == 0) {
        commit('snackbar', true);
        commit('showIdentitiesStatus');

        if (state.errorMsg != 'noIdentitiesTimed') {
          commit('errorMsg', 'noIdentities');
        }
        throw 'noIdentities';
      } else {
        window.onfocus = null;
        commit('snackbar', false);
      }
      // return the index of the last credetial added to show selected in dropdown
      // plus to skip wallid asset
      return lastIndex + 1;
    },
  },
  mutations: {
    msgID(state, value) {
      state.msgID = value;
    },
    showIdentitiesStatus(state) {
      state.showIdentitiesStatus = true;
    },
    currentUrl(state, value) {
      state.currentUrl = value;
    },
    step(state, step) {
      state.step = step;
    },
    decStep(state) {
      state.step--;
    },
    start(state) {
      state.step = 1;
      state.loading = false;
    },
    password(state, password) {
      state.password = password;
    },
    confirm(state, value) {
      state.confirmed = value;
    },
    loading(state, value) {
      state.loading = value;
    },
    dataIdentityIdEncrypted(state, value) {
      state.dataIdentityIdEncrypted = value;
    },
    idt(state, idt) {
      state.idt = idt;
    },
    dataVerifyIdEncrypted(state, value) {
      state.dataVerifyIdEncrypted = value;
    },
    dataIdentityId(state, identityId) {
      state.dataIdentityId = identityId;
    },
    dataVerifyId(state, verifyId) {
      state.dataVerifyId = verifyId;
    },
    data(state, data) {
      state.data = data;
    },
    terms(state, value) {
      state.terms = value;
    },

    signing(state, value) {
      state.signing = value;
    },
    verify(state, value) {
      state.verify = value;
    },
    redirectUrl(state, value) {
      state.redirectUrl = value;
    },
    verifyIDToken(state, value) {
      state.verifyIDToken = value;
    },
    snackbar(state, value) {
      state.snackbar = value;
    },
    errorMsg(state, value) {
      state.errorMsg = value;
    },
    documents(state, value) {
      state.documents = value;
    },
    envelopeID(state, value) {
      state.envelopeID = value;
    },
    authToken(state, value) {
      state.authToken = value;
    },
    idAssets(state, value) {
      state.idAssets = value;
    },
    errorMsgStatus(state, value) {
      state.errorMsgStatus = value;
    },
    addAsset(state, value) {
      state.idAssets.push(value);
    },
    selectedAsset(state, value) {
      state.selectedAsset = value;
    },
    // selectedAsset(state, value) {
    //   state.selectedAsset = value;
    // },
  },
  getters: {
    confirmed: (state) => state.confirmed,
    currentUrl: (state) => state.currentUrl,
    dropdown_identity: (state) => state.dropdown_identity,
    idt: (state) => state.idt,
    password: (state) => state.password,
    state: (state) => state,
    step: (state) => state.step,
    terms: (state) => state.terms,
    verify: (state) => state.verify,
    signing: (state) => state.signing,
    redirectUrl: (state) => state.redirectUrl,
    data: (state) => state.data,
    envelopeID: (state) => state.envelopeID,
    documents: (state) => state.documents,
    authToken: (state) => state.authToken,
    loading: (state) => state.loading,
    hasAssets: (state) => state.idAssets.length > 0,
    showIdentitiesStatus: (state) => state.showIdentitiesStatus,
    errorMsg: (state) => state.errorMsg,
    errorMsgStatus: (state) => state.errorMsgStatus,
  },
});

function handleError(error) {
  const err = error.response;
  logger.error(err);

  const errorMsg = {};

  errorMsg['event'] = 'response_error';
  errorMsg['event_category'] = 'error_complete_qes';

  if (err?.status == 401) {
    // GA Event Error
    errorMsg['event_label'] = 'session_expired';
    errorMsg['type'] = 'banner';
    errorMsg['message'] = 'expired';
  } else if (err?.data?.error?.status?.Code == 802) {
    // GA Event Error
    errorMsg['event_label'] = 'incorrect_code';
    errorMsg['type'] = 'otpCode';
    errorMsg['message'] = 'incorrectCode';
  } else if (err?.data?.error?.status?.Code == 816) {
    // GA Event Error
    errorMsg['event_label'] = 'expired_code';
    errorMsg['type'] = 'banner';
    errorMsg['message'] = 'expiredOtp';
  } else {
    // GA Event Error
    errorMsg['event_label'] = 'failed_signature';
    errorMsg['type'] = 'banner';
    errorMsg['message'] = 'failedsignature';
  }
  return errorMsg;
}
export default store;
